var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',[_c('Heading1',[_vm._v(_vm._s(_vm.content.title))])],1),_vm._v(" "),_c('Content',_vm._l((_vm.content.description),function(paragraph,i){return _c('Paragraph',{key:i,domProps:{"innerHTML":_vm._s(paragraph)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }